import React from 'react';
import { isEmail } from 'validator';

class TextEditorLink extends React.Component {
  constructor() {
    super();

    this.handleClick = this.handleClick.bind(this);

   }

   handleClick(e) {
    e.stopPropagation();
   }

  render() {



    const {
      baseUrlTamplate,      
    } = this.props;

    let customUrl = this.props.contentState.getEntity(this.props.entityKey).getData().url;
    let isFullUrl;
    let isEmailThis;

    if (customUrl && customUrl.includes('https://') || customUrl && customUrl.includes('http://')) {
      isFullUrl = true;
    }

    if (isEmail(customUrl)) {
      isEmailThis = true;
    }

    if (!isEmailThis && !isFullUrl && customUrl.charAt(0) !== '/') {
      return this.props.children;
    }

    const thisBaseTemplateUrl = baseUrlTamplate ? baseUrlTamplate : '';

    return (
      <a href={isEmailThis ? 'mailto:'+customUrl : isFullUrl ? customUrl : thisBaseTemplateUrl+customUrl} onClick={this.handleClick} target={isFullUrl ? '_blank' : '_self'} rel={'noopener'}>
        {this.props.children}
      </a>
    );
  }
}


export default TextEditorLink;